<template>
	<ul class="v-resume-questions">
		<li
			:key="`resume_question_${question.id}`"
			class="v-resume-questions__item"
			:class="{'v-resume-questions__item--active': activeQuestion == question.id}"
			v-for="question in questions"
			@click="selectQuestion(question.id)">
			<button
				class="v-resume-questions__play-button"
				:class="{'v-resume-questions__play-button--active': activeQuestion == question.id}">
				<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M17.3947 12.4812L12.128 7.96687C11.6848 7.58694 11 7.90189 11 8.48569V17.5143C11 18.0981 11.6848 18.4131 12.128 18.0331L17.3947 13.5188C17.7129 13.2461 17.7129 12.7539 17.3947 12.4812Z" class="v-resume-questions__play-button-path"/>
					<rect x="1" y="1" width="24" height="24" class="v-resume-questions__play-button-rect" rx="12" stroke-width="0.683319"/>
				</svg>
			</button>
			<v-resume-text :text="question.text" :class="{'v-resume-text--accent': activeQuestion == question.id}" />
		</li>
	</ul>
</template>
<script>
import VResumeText from '@/components_new/b2c/vresume-text/index'
export default {
	components: {
		VResumeText
	},
	props: {
		questions: Array,
		activeQuestion: Number
	},
	methods: {
		selectQuestion(id) {
			this.$emit('selectQuestion', id)
		}
	}
}
</script>
<style lang="scss" scoped>
.v-resume-questions {
	padding: 0;
	list-style-type: none;

	&__item {
		margin-bottom: 20px;
		cursor: pointer;
		transition: color .35s ease;
		// // font-family: 'Euclid Circular A';
		font-style: normal;
		font-weight: normal;
		font-size: 15px;
		line-height: 24px;
		display: flex;
		align-items: flex-start;
	}

	&__play-button {
		height: 24px;
		margin-right: 8px;
		path { fill: #C4B9D3; transition: fill .35s ease}
		rect { stroke: #C4B9D3; transition: stroke .35s ease}

		&--active path { fill: #AD6CE0; }
		&--active rect { stroke: #AD6CE0; }
	}
}
</style>
